const normalizeValue = (value: unknown): unknown => {
	if (Array.isArray(value)) {
		return value.map((item) => normalizeValue(item));
	}

	if (value && typeof value === 'object') {
		return Object.keys(value as Record<string, unknown>)
			.sort()
			.reduce((acc, key) => {
				const normalizedValue = normalizeValue((value as Record<string, unknown>)[key]);

				if (normalizedValue !== undefined) {
					acc[key] = normalizedValue;
				}

				return acc;
			}, {} as Record<string, unknown>);
	}

	return value;
};

export const stableStringify = (value: unknown) => JSON.stringify(normalizeValue(value));
